import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Card, Spinner } from "../../components/kd";
import { fmtDate } from "../../lib/format";

export function ReferrerList() {
  const [rows, setRows] = useState<any[] | null>(null);
  useEffect(() => { api.get("/admin/ueberweiser").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Spinner />;
  return (
    <Card className="!p-0 overflow-x-auto">
      <table className="w-full text-left text-sm" data-testid="referrers-table">
        <thead className="border-b border-border bg-bg text-text-muted"><tr>{["Name", "Praxis", "E-Mail", "Telefon", "Anzahl Fälle", "Letzter Fall"].map((h) => <th key={h} className="px-3 py-3 font-medium">{h}</th>)}</tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={6} className="px-3 py-4 text-text-muted">Noch keine Überweiser.</td></tr>}
          {rows.map((r) => (
            <tr key={r.id} className="border-b border-border last:border-0">
              <td className="px-3 py-3">{r.zahnarzt_name}</td><td className="px-3 py-3">{r.praxisname}</td><td className="px-3 py-3">{r.email}</td>
              <td className="px-3 py-3"><a href={`tel:${r.telefon}`}>{r.telefon}</a></td><td className="px-3 py-3">{r.anzahl_faelle}</td>
              <td className="px-3 py-3">{r.letzter_fall ? fmtDate(r.letzter_fall) : "–"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
